<clr-modal [(clrModalOpen)]="modalOpen">
  <h3 class="modal-title">{{ 'Objekt importieren' | mrTranslate }}</h3>
  <div class="modal-body clr-row nxm">
    <form id="import-form" clrForm (ngSubmit)="startImport()" clrLayout="horizontal" class="clr-col-12 width100">
      <clr-file-input-container [clrButtonLabel]="'Datei auswählen' | mrTranslate">
        <label>{{ 'Import' | mrTranslate }}</label>
        <input
          #filesInput
          type="file"
          clrFileInput
          [ngModel]="files()"
          (ngModelChange)="files.set($event)"
          [ngModelOptions]="{ standalone: true }"
          accept=".json,application/json"
          required />
        @if (jsonResource.value()) {
          <clr-control-success>
            {{ 'Import kann gestartet werden' | mrTranslate }}
          </clr-control-success>
        } @else {
          <clr-control-helper>
            {{ 'Wählen Sie eine zuvor exportierte Datei' | mrTranslate }}
          </clr-control-helper>
        }
        <clr-control-error *clrIfError="'required'">
          {{ 'Erforderlich' | mrTranslate }}
        </clr-control-error>
        <clr-control-error *clrIfError="'accept'">
          {{ 'Please only upload json files' | mrTranslate }}
        </clr-control-error>
      </clr-file-input-container>
    </form>
  </div>
  <div class="modal-footer">
    @let group = progressGroup();
    @let status = group.status;
    @if (status != 'pending') {
      @if (status != 'done') {
        <button class="btn btn-primary" type="submit" form="import-form" [disabled]="!jsonResource.value()">
          <cds-icon shape="upload-cloud" />
          {{ 'Importieren' | mrTranslate }}
        </button>
      }
      <button type="button" class="btn" (click)="modalOpen.set(false)">
        {{ 'Beenden' | mrTranslate }}
      </button>
    } @else {
      <div class="progress-group w-100-p">
        @for (child of group.children | keyvalue: null; track child.key) {
          @let progress = child.value;
          <div class="progress-block">
            <label>{{ progress.title | mrTranslate }}</label>
            <clr-progress-bar
              [clrValue]="progress.percent"
              [clrLabeled]="!progress.total"
              clrColor="success" />
            @if (progress.total) {
              <span class="margin-6-l">{{ progress.current ?? 0 }} / {{ progress.total }}</span>
            }
          </div>
        }
      </div>
    }
  </div>
</clr-modal>
